module.exports = __webpack_public_path__ + "img/13.22d0c364.jpg";